export default __webpack_public_path__ + "static/media/5_6.43195f29.png";